import HelpOutlineIcon from "@mui/icons-material/HelpOutlineRounded";
import { Tooltip } from "@mui/material";
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

const FieldHelp = ({ children }: Props) => (
  <Tooltip title={children} arrow placement="right">
    <HelpOutlineIcon fontSize="small" color="action" sx={{ ml: 1 }} />
  </Tooltip>
);

export default FieldHelp;
